import Chart from '@/components/chart-settings'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'SummaryChart',
  props: {
    dataChart: {
      type: Array,
      default: () => []
    },
    currency: {
      type: Boolean,
      default: true
    }
  },
  static() {
    return {
      chartObject: null,
      chartOptions: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: -10,
            bottom: -10
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            mode: 'index',
            intersect: false,
            /**
             * подставится в created
             */
            external: null
          }
        },
        scales: {
          x: {
            grid: {
              drawBorder: false,
              display: false
            },
            ticks: {
              display: false,
              backdropPadding: 0,
              fontSize: 0
            }
          },
          y: {
            grid: {
              drawBorder: false,
              display: false
            },
            ticks: {
              display: false,
              backdropPadding: 0,
              fontSize: 0,
              /**
               * поменяется в getFullData
               */
              stepSize: 1
            }
          }
        }
      }
    }
  },
  data() {
    return {
      tootipData: {
        date: '',
        value: ''
      },
      tooltipStyle: {
        left: 0,
        top: 0,
        opacity: 0
      }
    }
  },
  created() {
    this.chartOptions.plugins.tooltip.external = this.externalTooltipHandler
  },
  mounted() {
    this.renderUpdateChart()
  },
  methods: {
    getFullData() {
      const labels = this.dataChart.map(item => item.date)
      const dataArr = this.dataChart.map(item => item.value)
      const maxValue = Math.max(...dataArr)
      /**
       * максимальное количество ticks - 1000
       */
      let stepSize = Math.ceil(maxValue / 1000)
      this.chartOptions.scales.y.ticks.stepSize = stepSize
      return {
        labels,
        datasets: [{
          data: dataArr,
          backgroundColor: '#593289'
        }]
      }
    },
    renderUpdateChart() {
      const newData = this.getFullData()
      if (!this.chartObject) {
        this.chartObject = new Chart(
          this.$refs.canvas,
          {
            type: 'bar',
            data: newData,
            options: this.chartOptions
          }
        )
      } else {
        this.chartObject.data = newData
        this.chartObject.update()
      }
    },
    externalTooltipHandler(chartContext) {
      const { tooltip } = chartContext
      const date = tooltip.title[0]
      const dataPoint = tooltip.dataPoints[0]
      const value = dataPoint.dataset.data[dataPoint.dataIndex]
      this.tootipData = {
        date,
        value: `${numberWithSeparator(value)}${this.currency ? ' ₽' : ''}`
      }
      this.tooltipStyle.opacity = tooltip.opacity
      if (tooltip.opacity) {
        this.$nextTick(() => {
          const rectTooltip = this.$refs.tooltip.getBoundingClientRect()
          const tooltipMargin = 4
          this.tooltipStyle.left = `${tooltip.caretX - rectTooltip.width - tooltipMargin}px`
          this.tooltipStyle.top = `${tooltip.caretY + tooltipMargin}px`
        })
      }
      
    }
  },
  watch: {
    dataChart() {
      this.renderUpdateChart()
    }
  }
}